export abstract class LogoutService {
    logout:() => Promise<any>
    removeTokens:() => void
}